export const TEXT_TYPE_URI =
  'urn:replicon:object-extension-definition-type:object-extension-type-text';
export const NUMERIC_TYPE_URI =
  'urn:replicon:object-extension-definition-type:object-extension-type-numeric';
export const TAG_TYPE_URI =
  'urn:replicon:object-extension-definition-type:object-extension-type-tag';
export const FILE_TYPE_URI =
  'urn:replicon:object-extension-definition-type:object-extension-type-file';
